"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIARY_ENTRY_TYPES = exports.DiaryEntryType = void 0;
var DiaryEntryType;
(function (DiaryEntryType) {
    DiaryEntryType["INFORMACE"] = "informace";
    DiaryEntryType["ZAVADA"] = "z\u00E1vada";
    DiaryEntryType["SERVIS"] = "servis";
    DiaryEntryType["REVIZE"] = "revize";
})(DiaryEntryType || (exports.DiaryEntryType = DiaryEntryType = {}));
;
exports.DIARY_ENTRY_TYPES = [DiaryEntryType.ZAVADA, DiaryEntryType.INFORMACE, DiaryEntryType.SERVIS, DiaryEntryType.REVIZE];
